<div class="card card-custom gutter-b card-stretch">
    <div class="card-body">
        <div class="database_view h-100">
            <div class="row h-100">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-10">
                            <div class="row breadcume" style="width: 100%">
                                <div class="row">
                                    <div class="breadcume-item">
                                        <h3 style="font-size: 14px" title="ICE Database">
                                            <span>ICE Database</span>
                                        </h3>
                                    </div>

                                    <div class="breadcume-item" *ngIf="selectedData">
                                        <h3 style="font-size: 14px" title="{{ selectedData?.name }}">
                                            <i class="fa fa-angle-right" aria-hidden="true" style="font-size: 14px; margin: 0px 5px; color: #337ab7"></i>
                                            <span>{{ selectedData?.name }}</span>
                                        </h3>
                                    </div>
                                    <div class="breadcume-item" *ngIf="selectedTable">
                                        <h3 style="font-size: 14px" title="{{ selectedTable }}">
                                            <i class="fa fa-angle-right" aria-hidden="true" style="font-size: 14px; margin: 0px 5px; color: #337ab7"></i>
                                            <span>{{ selectedTable }}</span>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2 search-wrapper">
                            <mat-form-field *ngIf="selectedData && !selectedTable">
                                <input matInput type="text" placeholder="Search" autocomplete="off" (keyup)="searchResult($event)" [(ngModel)]="searchInput" />
                                <button mat-button matPrefix mat-icon-button class="search_btn">
                                    <mat-icon class="serach_icon">search</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="mat-typography left_tree accordion-wrap">
                        <div class="layout-wrapper" *ngIf="!selectedData && !selectedTable">
                            <div *ngFor="let item of databaseDetails">
                                <div class="card">
                                    <div class="card-item text-truncate">
                                        <a href="javascript:void(0)"> <i class="mdi mdi-folder-table-outline"></i></a>
                                        <h5 class="text-truncate" style="cursor: pointer" (click)="selectedTableItem(item)">{{ item.name }}</h5>
                                    </div>
                                    <a
                                        href="javascript:void(0)"
                                        #tooltip="matTooltip"
                                        matTooltip="View Details"
                                        matTooltipPosition="above"
                                        (click)="selectedTableItem(item)"
                                    >
                                        <i class="fas fa-eye" style="font-size: 20px"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="layout-wrapper" *ngIf="selectedData && !selectedTable">
                            <div *ngFor="let item of copySelectedData.tableList">
                                <div class="card">
                                    <div class="card-item text-truncate">
                                        <a href="javascript:void(0)"> <i class="mdi mdi-table"></i></a>
                                        <h5
                                            class="text-truncate"
                                            style="cursor: pointer"
                                            #tooltip="matTooltip"
                                            [matTooltip]="item.name"
                                            matTooltipPosition="above"
                                            (click)="selectedTableName(item.name)"
                                        >
                                            {{ item.name }}
                                        </h5>
                                    </div>
                                    <a
                                        href="javascript:void(0)"
                                        #tooltip="matTooltip"
                                        matTooltip="View Details"
                                        matTooltipPosition="above"
                                        (click)="selectedTableName(item.name)"
                                    >
                                        <i class="fas fa-eye" style="font-size: 20px"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="selectedTable">
                            <app-ice-grid [selectedTable]="selectedTable" [defaultFilter]="selectedFilter"></app-ice-grid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
